module.exports = __webpack_public_path__ + "img/clinic-right.e153d6d8.png";